export interface KahlMessage {
  id: string;
  kahlId: string;
  displayType: KahlDisplayTypeEnum;
  text: string;
  stacktrace?: Array<string>;
  textInternal: string;
  errorType: string;
  internal: boolean;
  generality: KahlGeneralityEnum;
  journalable: boolean;
}

export enum KahlDisplayTypeEnum {
  OVERLAY = 'OVERLAY',
  STANDALONE = 'STANDALONE',
}

export enum KahlGeneralityEnum {
  GENERAL = 'GENERAL',
  SPECIFIC = 'SPECIFIC',
}

export interface GetKahlPayload {
  infoMessageIds?: string;
  exceptionParamMaps?: string | Record<string, string>;
  stacktrace?: string;
}

export const KahlSeverityMap: Record<string, 'error' | 'info' | 'success' | 'warning'> = {
  '1': 'error',
  '2': 'success',
  '3': 'warning',
  '4': 'info',
};
